/**
 *Created by jmmartinez on 03/05/19
 * v 1.1 03/07/2019 Comprobacion en OnChange para evitar error ante selección de misma fecha
 * v 1.2 24/09/2019 Modificacion onChange para poner la 0 a cero si no hay q mostrar la hora.
 * v.1.3 25/02/2020 En render cambiada la asignacion de valorDate para ver si es obligatorio o no
 *                  Añadido maxDate en la llamada a DateInput
 *                  Añadida propiedad obligatorio
 *                  Eliminado defaultValue en la llamada al componente DateInput
 * v.1.4 20/03/2020 Modificado en el render la fecha mínima: minDate
 * v.1.5 26/05/2020 Añadido import "../../planifikator/resources/css/datepicker.css" para corregir que quepa el mes en el datepicker
 * v.1.6 04/06/2020 Creada funcion formateador que se pasa como funcion a parseDate.
 * v.2.0 30/09/2020 Cambiado a framework2
 **/

import React from 'react'
import PropTypes from 'prop-types';

import {DateInput, TimePrecision} from "@blueprintjs/datetime";
import {Position} from "@blueprintjs/core";
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import {DateFormatStrings} from "./DayPickerProps"
import moment from "moment";
import {getDateFromFormattedString} from "../ej2/utils/DateUtils";
import "../resources/css/datepicker.css"
import {transformadorCadenaFecha} from "../ej2/utils/Transformadores";



class DateTimeInput extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            valor: props.valor,
        }
    }


    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState){
        const newState = {};

        if( nextProps.valor !== prevState.valor){
            newState.valor= nextProps.valor;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    onChange= (datetime) => {
        const {conHora, onChange, obligatorio} = this.props;
        if (datetime){
            let mostrarHora= conHora && (typeof conHora === 'boolean' && conHora === true);
            if (!mostrarHora) {
                datetime.setHours(0);
                datetime.setMinutes(0);
                datetime.setSeconds(0);
                datetime.setMilliseconds(0);
            }
            onChange && onChange(datetime.getTime());
        }
        else{
            onChange && onChange(null);
        }
    }


    getFormat= (formatoCadena) => {
        let a= {
            formatDate: date => moment(date).format(formatoCadena),
            parseDate: str => moment(str, formatoCadena).toDate(),
            placeholder: `${formatoCadena} (moment)`
        };
        console.log(a);

        return {
            formatDate: date => moment(date).format(formatoCadena),
            parseDate: str => moment(str, formatoCadena).toDate(),
            placeholder: `${formatoCadena} (moment)`
        };
    }

    onError= (date) => {
        alert("Error");
        console.log(date);
    }

    formateador= (cadena) => {
        console.log ("DateTimeInput - Formateador: ", cadena);
        let fecha= transformadorCadenaFecha(cadena);
        return fecha;
    }

    render() {
        const {valor} = this.state;
        const {conHora, obligatorio} = this.props;
        let bObligatorio= Boolean(obligatorio);
        let valorDate= valor ? new Date(valor): bObligatorio ? new Date() : null;

        console.log("DATETIMEINPUT - RENDER");
        console.log("valorDate: ", valorDate);

        let mostrarHora= (typeof conHora === 'boolean' && conHora === true);
        let placeHolder= mostrarHora ?  "DD/MM/YYYY hh:mm:ss" : "DD/MM/YYYY";
        let formato= mostrarHora ? this.getFormat("DD/MM/YYYY HH:mm:ss") :  this.getFormat("DD/MM/YYYY");

        return(
            <DateInput
                formatDate= {formato.formatDate}
                //parseDate= {formato.parseDate}
                parseDate={this.formateador}
                placeholder= {placeHolder}
                //defaultValue={ valorDate}
                value={valorDate}
                onChange={this.onChange}
                popoverProps={{ position: Position.BOTTOM }}
                timePrecision= { mostrarHora ? TimePrecision.SECOND : null}
                dayPickerProps= { DateFormatStrings  }
                onError={this.onError}
                maxDate={getDateFromFormattedString("31/12/2029")}
                minDate={getDateFromFormattedString("1/1/1930")}

            />
        );
    }

}


DateTimeInput.propTypes = {
    id: PropTypes.string,
    conHora: PropTypes.bool,
    onChange: PropTypes.func,
    valor: PropTypes.number,
    obligatorio: PropTypes.bool,
}

export default DateTimeInput

